import findLast from 'array.prototype.findlast';

if (typeof Array.prototype.findLast !== 'function') {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-call
  findLast.shim();
}
